import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { URL } from "../../../constants/URL";
import {
	useGetEmailById,
	useGetEmailVariablesById,
	useUpdateEmailById,
} from "../../../queryHooks";
import CS from "../../../services/commonService";
import { updateEmailTemplateSchema } from "../../../validations/emailValidations";
import BreadCrumbs from "../../common/breadcrumbs";
import Editor from "../../common/editor";

const EmailTemplateAddUpdate = () => {
	const { slug } = useParams();
	const navigate = useNavigate();

	const [emailTitle, setEmailTitle] = useState("");
	/******************************************************************************************
    @Purpose    :   To get the email template details and it's variables
    *******************************************************************************************/

	const { data: emailData, error: emailError } = useGetEmailById(slug);
	const { data: emailVariablesData, error: emailVariablesError } =
		useGetEmailVariablesById(slug);

	useEffect(() => {
		if (emailData) {
			const { data } = emailData;
			setEmailTitle(data?.[0].label);
			// setDescription(data?.[0]?.email_body);
			formValues.email_subject = data?.[0]?.email_subject;
			formValues.code = data?.[0]?.code;
			formValues.email_body = data?.[0]?.email_body;
		}
	}, [emailData]);

	useEffect(() => {
		if (emailError) {
			CS.showErrorMessage(emailError?.data?.message || emailError?.message);
		}
	}, [emailError]);

	useEffect(() => {
		if (emailVariablesError) {
			CS.showErrorMessage(
				emailVariablesError?.data?.message || emailVariablesError?.message
			);
		}
	}, [emailVariablesError]);

	/******************************************************************************************
    @Purpose    :   To update email template
    *******************************************************************************************/

	const {
		mutateAsync: updateEmailTemplate,
		data: updateTemplateData,
		error: updateTemplateError,
	} = useUpdateEmailById();

	const {
		values: formValues,
		errors: formErrors,
		handleChange,
		handleSubmit,
		touched,
	} = useFormik({
		initialValues: {
			code: "",
			email_subject: "",
			email_body: "",
		},
		validationSchema: updateEmailTemplateSchema,
		onSubmit: (value) => {
			updateEmailTemplate({
				data: value,
				id: slug,
			});
		},
	});

	useEffect(() => {
		if (updateTemplateData) {
			CS.showSuccessMessage(
				updateTemplateData?.data?.message || updateTemplateData?.message
			);
			navigate(URL.emailTemplates, { replace: true });
		}
	}, [updateTemplateData]);

	useEffect(() => {
		if (updateTemplateError) {
			CS.showSuccessMessage(
				updateTemplateError?.data?.message || updateTemplateError?.message
			);
		}
	}, [updateTemplateError]);

	return (
		<form onSubmit={handleSubmit}>
			{slug === "add" ? (
				<BreadCrumbs
					title={"Email Templates"}
					data={[
						{ label: "Email Templates", path: URL.emailTemplates },
						{ label: "Add Email Template" },
					]}
				/>
			) : (
				<BreadCrumbs
					title={"Email Templates"}
					data={[
						{ label: "Email Templates", path: URL.emailTemplates },
						{ label: "Update Email Templates" },
					]}
				/>
			)}
			<div className="blog-content-block w-100">
				<div className="card card-media">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group mb-md-5 mb-3">
								<label htmlFor="emailTitle">
									Email Title<sup className="text-danger">*</sup>
								</label>
								<input
									type="text"
									className="form-control"
									id="emailTitle"
									name="emailTitle"
									placeholder="Email Title"
									value={emailTitle}
									// maxLength="70"
									readOnly
									disabled
									// onChange={(e) => setEmailTitle(e.target.value)}
								/>
								{/* <span className="text-danger d-block">{touched && formErrors.}</span> */}
							</div>
							<div className="form-group mb-md-5 mb-3">
								<label htmlFor="emailKey">
									Email Key<sup className="text-danger">*</sup>
								</label>
								<input
									type="text"
									className="form-control"
									id="code"
									name="code"
									placeholder="Email Key"
									disabled={slug !== "add"}
									value={formValues.code}
									onChange={handleChange}
								/>
								{/* <span className="text-danger d-block">{errors.emailKey}</span> */}
							</div>
							<div className="form-group mb-md-5 mb-3">
								<label htmlFor="subject">
									Subject<sup className="text-danger">*</sup>
								</label>
								<input
									type="text"
									className="form-control"
									id="email_subject"
									name="email_subject"
									placeholder="Subject"
									value={formValues.email_subject}
									onChange={handleChange}
								/>
								<span className="text-danger d-block">
									{touched && formErrors.email_subject
										? formErrors.email_subject
										: null}
								</span>
							</div>
							<div className="form-group mb-md-5 mb-3">
								<label htmlFor="subject">
									Body<sup className="text-danger">*</sup>
								</label>
								<Editor
									description={formValues.email_body}
									setDescription={handleChange}
									variables={emailVariablesData?.data}
								/>
								<span className="text-danger d-block">
									<span className="text-danger d-block">
										{touched && formErrors.email_body
											? formErrors.email_body
											: null}
									</span>
								</span>
							</div>
						</div>
					</div>
					<div className="d-flex align-items-center justify-content-end mt-3">
						<div className="form-group">
							<div className="button-group-container">
								<button
									className="btn btn-primary mr-3 mb-sm-0 mb-2"
									type="submit"
								>
									{slug === "add" ? "Add" : "Update"}
								</button>
								<Link
									className="btn btn-outline-primary"
									to={URL.emailTemplates}
								>
									Cancel
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	);
};

export default EmailTemplateAddUpdate;
